import React from "react";
import AppLayout from "@amzn/awsui-components-react-v3/polaris/app-layout";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Content from "./layout/Content";
import { RootState } from "./redux/rootReducer";
import HelpPanelMenu from "./help_panel/HelpPanelMenu";
import { DisplayHelpPanel } from "./help_panel/helpPanelSlice";
import helpPanelSlice from "./help_panel/helpPanelSlice";

interface StateProps {
  helpPanelContents: DisplayHelpPanel | undefined;
  helpPanelOpenState: boolean | undefined;
}

interface DispatchProps {
  setHelpPanelOpenState: (open: boolean) => void;
}

const App: React.FC<StateProps & DispatchProps> = ({
  helpPanelOpenState,
  helpPanelContents,
  setHelpPanelOpenState,
}): JSX.Element => {
  return (
    <div style={{ margin: 0, padding: 0, width: "100%", height: "100vh" }}>
      <AppLayout
        navigationHide
        toolsHide={!helpPanelContents}
        toolsOpen={helpPanelOpenState}
        onToolsChange={({ detail }) => setHelpPanelOpenState(detail.open)}
        tools={<HelpPanelMenu />}
        content={<Content />}
        contentType="default"
        disableContentPaddings
      />
    </div>
  );
};

const mapStateToProperties = ({ helpPanel }: RootState): StateProps => {
  return {
    helpPanelContents: helpPanel.displayHelpPanel,
    helpPanelOpenState: helpPanel.helpPanelOpenState,
  };
};

const mapDispatchToProperties = (dispatch: Dispatch): DispatchProps => ({
  setHelpPanelOpenState: (open: boolean) => {
    dispatch(helpPanelSlice.actions.setHelpPanelOpenState(open));
  },
});

export default connect(mapStateToProperties, mapDispatchToProperties)(App);
